import React, { useMemo } from "react";
import MalePersonFrontImage from "@shared/assets/person/male/person-front.svg?react";
import MalePersonBackImage from "@shared/assets/person/male/person-back.svg?react";
import MalePersonLeftImage from "@shared/assets/person/male/person-left.svg?react";
import MalePersonRightImage from "@shared/assets/person/male/person-right.svg?react";
import FemalePersonFrontImage from "@shared/assets/person/female/person-front.svg?react";
import FemalePersonBackImage from "@shared/assets/person/female/person-back.svg?react";
import FemalePersonLeftImage from "@shared/assets/person/female/person-left.svg?react";
import FemalePersonRightImage from "@shared/assets/person/female/person-right.svg?react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { ComplaintsOverview } from "../complaints/overview";

const getPerspectives = (gender?: string) => {
  if (gender === "female") {
    return {
      front: {
        SvgComponent: FemalePersonFrontImage,
        width: 184,
        height: 442,
      },
      back: {
        SvgComponent: FemalePersonBackImage,
        width: 186,
        height: 442,
      },
      left: {
        SvgComponent: FemalePersonLeftImage,
        width: 109,
        height: 442,
      },
      right: {
        SvgComponent: FemalePersonRightImage,
        width: 109,
        height: 442,
      },
    };
  }

  return {
    front: {
      SvgComponent: MalePersonFrontImage,
      width: 192,
      height: 442,
    },
    back: {
      SvgComponent: MalePersonBackImage,
      width: 196,
      height: 442,
    },
    left: {
      SvgComponent: MalePersonLeftImage,
      width: 112,
      height: 442,
    },
    right: {
      SvgComponent: MalePersonRightImage,
      width: 112,
      height: 442,
    },
  };
};

type ControlledBodyComplaintsMapProps = {
  gender?: string;
  name: string;
  control: Control<FieldValues>;
};

export const ControlledBodyComplaintsMap: React.FC<
  ControlledBodyComplaintsMapProps
> = ({ gender, control, name }) => {
  const perspectives = useMemo(() => getPerspectives(gender), [gender]);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <ComplaintsOverview
          value={field.value}
          onChange={field.onChange}
          {...perspectives}
        />
      )}
    />
  );
};
